(function ($, document) {
	'use strict';

	$(document).ready(function () {
		$('.js-read-more-content').each(function () {
			const content = $(this);
			const toggle = $(this).find('.js-read-more-toggle');

			$(toggle).on('click', function (e) {
				e.preventDefault();

				content.toggleClass('is-expanded');

				if ($(this).text() === 'Read More') {
					$(this).text('Read Less');
				} else if ($(this).text() === 'Read Less') {
					$(this).text('Read More');

					// Scroll to keep your position when you close.
					// $([document.documentElement, document.body]).animate({
					//     scrollTop: content.offset().top
					// }, 500);
				}
			});
		});
	});

})(jQuery, document);
